import React from 'react';
import { authUserData } from '../../service';
import AdminDashboard from '../../components/AdminDashboard';
import BrandManagementContent from './BrandManagementContent';

// Fleet entry exposes incoming brand dispatches using its existing Redux identity.
export default function BrandManagement() {
  return (
    <AdminDashboard title="品牌派單">
      <BrandManagementContent fleetOnly user={authUserData()} />
    </AdminDashboard>
  );
}
